import React, { useRef, useState, useCallback, useEffect } from "react";
import { CarOutlined, SendOutlined } from "@ant-design/icons";
import { Modal, Button, Form, Row, Col, message } from "antd";
import { shareShipment } from "@/services/shipments_new";
import EmailInput from "@/components/EmailInput";
import CopyTrackingLink from "../CopyTrackingLink";
import PhoneNumberInput, { flatPhoneNumber } from "../PhoneNumberInput";

const ShareMyRide = ({ isMenuItem = false, shipmentId, modalVisible, setModalVisible, style = { marginTop: 22 } }) => {
  const shareRideForm = useRef();

  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = useCallback(() => {
    setVisible(true);

    if (typeof setModalVisible === "function") {
      setModalVisible(true);
    }
  }, [setModalVisible]);

  const hideModal = useCallback(() => {
    setVisible(false);

    if (typeof setModalVisible === "function") {
      setModalVisible(false);
    }
  }, [setModalVisible]);

  const handleOk = useCallback(() => {
    shareRideForm.current.validateFields().then(result => {
      if (!result.email && result.phoneNumber.phoneNumber === null) {
        message.error("Please enter an email or phone number");
        return;
      }

      setLoading(true);

      const payload = {
        id: shipmentId,
        email: result.email,
        phoneNumber: flatPhoneNumber(result.phoneNumber),
      };

      shareShipment(payload)
        .then(() => {
          shareRideForm.current.resetFields();
          hideModal();
          message.success("Shipment shared successfully");
        })
        .catch(error => {
          console.error(error);
          message.error("Error sending: invalid phone or email");
        })
        .finally(() => {
          setLoading(false);
        });
    });
  }, [shipmentId, hideModal]);

  const handleCancel = useCallback(() => {
    shareRideForm.current.resetFields();
    hideModal();
  }, [hideModal]);

  useEffect(() => {
    if (modalVisible !== visible && typeof modalVisible === "boolean") {
      setVisible(modalVisible);
    }
  }, [modalVisible, visible]);

  return (
    <div style={isMenuItem ? { display: "inline" } : style}>
      {isMenuItem ? (
        <span>Share</span>
      ) : (
        <Button icon={<CarOutlined />} type="primary" onClick={showModal}>
          Share
        </Button>
      )}
      <Modal
        title="Share my Shipment"
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
        okText={
          <>
            <SendOutlined /> <span style={{ marginLeft: 5 }}>Send</span>
          </>
        }
      >
        <p
          style={{
            color: "rgba(0, 0, 0, 0.65)",
            marginBottom: 32,
          }}
        >
          Share vehicle shipment details and location by entering a phone number, email or copying the link.
        </p>
        <Form layout="vertical" ref={shareRideForm}>
          <Row gutter={16} wrap>
            <Col lg={24} style={{ width: 1000 }}>
              <PhoneNumberInput
                showExtensionInput={false}
                formItemProps={{
                  name: "phoneNumber",
                  label: "Phone Number",
                  formRef: shareRideForm,
                }}
              />
            </Col>
          </Row>
          <div style={{ marginBottom: 24, fontWeight: "bold" }}>and/or</div>
          <Row gutter={16}>
            <Col lg={24}>
              <EmailInput />
            </Col>
          </Row>
        </Form>
        <CopyTrackingLink shipmentId={shipmentId} />
      </Modal>
    </div>
  );
};

export default ShareMyRide;
